"use strict";

// We support variant switching using either a select, or a series of buttons/anchors.

function showVariant(variantID) {
    var variantFragmentPrefix = $('.js-product-variant-switcher').data('url-fragment-prefix');
    history.replaceState(null, '', `#${variantFragmentPrefix}${variantID}`);
    $('.js-product-variants__variant').addClass('d-none')
        .filter(`[data-id="${variantID}"]`).removeClass('d-none');
    // Force the thumbnail slider for the gallery to reload
    $('.catalogue-gallery-thumbnails-switcher').sly('reload');
}

$('select.js-variant-switcher').on('change', function(e){
    showVariant($(this).val());
});

$('a.js-variant-switcher, button.js-variant-switcher').on('click', function(e){
    e.preventDefault();
    $(this).addClass('active').siblings().removeClass('active');
    showVariant($(this).data('id'));
});

$(function() {
    const variantHashPrefix = '#' + $('.js-product-variant-switcher').data('url-fragment-prefix');
    if (window.location.hash.indexOf(variantHashPrefix) === 0) {
        const variantID = window.location.hash.substring(variantHashPrefix.length)
        $(`.js-variant-switcher[data-id="${variantID}"]`).click();
    }
});
